import "./Loading.css";

export default function Loading() {
  return (
    <div className="Loading">
      <img alt="Logo" src="/assets/Logo.png" width="165" height="69" />
    </div>
  );
}